export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <a href="#hero" className="font-heading text-xl md:text-2xl font-bold whitespace-nowrap">
              <span className="text-primary-400">吃瓜</span>黑料爆料
            </a>
            <p className="mt-4 text-sm text-white/50 leading-relaxed max-w-sm">
              吃瓜黑料爆料网是国内领先的娱乐八卦聚合平台，为您集中汇总娱乐圈最新黑料、明星八卦爆料，涵盖出轨内幕、丑闻细节等热门吃瓜事件合集。一站式浏览全网瓜料，不错过任何娱乐八卦。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 text-white/80">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#index" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">瓜料合集</a>
              <a href="#carousel" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">重磅深扒</a>
              <a href="#ranking" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热搜黑料榜</a>
              <a href="#updates" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">最新快讯</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 text-white/80">关于我们</h4>
            <div className="flex flex-col gap-2">
              <a href="#about" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">平台介绍</a>
              <a href="#faq" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
              <a href="#contact" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">爆料投稿</a>
              <a href="#comments" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">瓜友热评</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 text-white/80">合作伙伴</h4>
            <p className="text-sm text-white/40">敬请期待</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            &copy; 2026 吃瓜黑料爆料网. All rights reserved.
          </p>
          <p className="text-xs text-white/30">
            本站内容仅供娱乐参考，不构成任何事实认定依据
          </p>
        </div>
      </div>
    </footer>
  );
}